export default __webpack_public_path__ + "static/media/population-zero.11c04ac8.png";